import React from 'react'
import Dropdown from '../../../../DropDown/Dropdown'
import Search from '../../../../Search/Search'
import Icon from '../../../../Icon2/Icon'
import Tooltip from '../../../../Tooltip/Tooltip'

import cn from 'classnames'
import styles from './style.module.css';

export function AssetSearch({ t = (key: string) => '', listType, onDisplayTypeChange, onQueryChange, assetsCount, selectedAssetsCount, showSearchBox }) {
  const dropdownList = [
    {
      label: <span className={styles['dropdown-item']}><Icon icon='List' className={styles['margin-right']} /> {t('AssetPicker.list') || 'List'}</span>,
      action: () => {
        onDisplayTypeChange("list")
      },
      default: listType === 'list',
    },
    {
      label: <span className={styles['dropdown-item']}><Icon icon='Thumbnail' className={styles['margin-right']} /> {t('AssetPicker.thumbnail') || 'Thumbnail'}</span>,
      action: () => {
        onDisplayTypeChange("grid")
      },
      default: listType === 'grid',
    },
  ]

  function handleSearchChange(searchInput: string) {
    onQueryChange(searchInput)
  }

  const searchContainer = cn(styles['scrte-search'], {
    [styles['exclude-search']]: !showSearchBox
  })

  const dropDownWrapper = cn('Dropdown-wrapper', {
    [styles['dropdown-on-right']]: !showSearchBox
  })

  const assetsCountCn = cn(styles['asset-count'], {
    [styles['selected-assets-count']]: !showSearchBox
  })

  return (
    <div className={searchContainer}>
      {showSearchBox && (<Search
        width="full"
        placeholder={t('AssetPicker.search_assets') || 'Search Assets'}
        corners="regular"
        debounceSearch={true}
        onChange={handleSearchChange}
      />)}
      <div className={styles['asset-view-controls']}>
        <p
          className={assetsCountCn}>
          {showSearchBox ? assetsCount : selectedAssetsCount} {t('AssetPicker.items') || 'items'}
        </p>
        <div className={dropDownWrapper}>
          <Dropdown closeAfterSelect={true} list={dropdownList} type="click" highlightActive={true} withArrow={true} dropDownPosition="left" >
            <Tooltip content={t('AssetPicker.change_view') || 'Change view'} position="top">
              {listType === 'list' ? <Icon icon="List" className="List__icon" testId='list_button' /> : <Icon icon="Thumbnail" className="List__icon" testId='thumbnail_button' />}
            </Tooltip>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}
